import type { Messages } from "@/i18n/locales/en";
import { legalMessagesLt } from "@/i18n/locales/legalLtData";
import { pagesMessagesLt } from "@/i18n/locales/pagesLtData";

export const ltMessages = {
  meta: {
    description:
      "WasOK — nuskaitykite produktus, išsaugokite įvertinimus ir pastabas, prisiminkite, kas buvo verta pirkti.",
    title: "WasOK — Prisiminkite, kas buvo verta pirkti",
  },
  header: {
    navFeatures: "Funkcijos",
    navHowItWorks: "Kaip veikia",
    navPrivacy: "Privatumas",
    navUseCases: "Pritaikymas",
    download: "Atsisiųsti",
    openMenu: "Atidaryti meniu",
    closeMenu: "Uždaryti meniu",
    languageAria: "Kalba",
  },
  hero: {
    badge: "📱 Dabar prieinama „Android“",
    title: "Prisiminkite, kas buvo verta pirkti.",
    subtitle:
      "Nuskaitykite produktus, išsaugokite įvertinimus ir pastabas — ir iškart prisiminkite, ar produktas tikrai buvo geras.",
    googlePlay: "Atsisiųsti iš Google Play",
    watchDemo: "Žiūrėti demonstraciją",
    privacyLine: "Visi duomenys lieka jūsų įrenginyje.",
    phoneTitle: "WasOK",
    phoneSubtitle: "Nuskaitykite, kad prisimintumėte",
    snackCard: "Skanu!",
    coffeeCard: "Per karti",
    scrollHint: "Slinkite, kad tyrinėtumėte",
  },
  problems: {
    heading: "Skamba pažįstamai?",
    subheading:
      "Visi esame ten buvę — stovime prie lentynų ir bandome prisiminti, ar mums patiko paskutinį kartą.",
    notedAgo: "✓ Tai pažymėjote prieš 3 mėnesius",
    items: [
      {
        question: "Kurį šokoladą man iš tikrųjų patiko?",
        note: "Tobulas saldumas",
      },
      {
        question: "Kodėl nustojau pirkti šį šampūną?",
        note: "Išsausino plaukus",
      },
      {
        question: "Ar ši kava buvo gera, ar nuvylė?",
        note: "Per karti",
      },
    ],
  },
  howItWorks: {
    heading: "Kaip veikia",
    subheading:
      "Keturi paprasti žingsniai, kad daugiau niekada nepamirštumėte savo nuomonės apie produktus.",
    stepPrefix: "Žingsnis",
    steps: [
      {
        title: "Nuskaitykite bet kurio produkto brūkšninį kodą",
        description:
          "Greitas ir paprastas nuskaitymas kamera. Veikia su bet kokiu brūkšniniu kodu.",
      },
      {
        title: "Išsaugokite įvertinimus, komentarus ir nuotraukas",
        description:
          "Įvertinkite produktus, pridėkite pastabas, nuotraukas, kainas ir vietas.",
      },
      {
        title: "Iškart prisiminkite savo patirtį",
        description:
          "Vėliau nuskaitykite tą patį produktą ir pamatykite ankstesnį įvertinimą bei pastabas.",
      },
      {
        title: "Kurkite išmanius pirkinių sąrašus",
        description:
          "Kurkite pirkinių sąrašus iš produktų, kuriais jau pasitikite ir mėgstate.",
      },
    ],
  },
  privacy: {
    heading: "Jūsų pirkinių istorija lieka jūsų.",
    body: "WasOK padeda prisiminti išbandytus produktus, o įvertinimai, pastabos, nuotraukos ir pirkinių sąrašai saugomi vietiniu būdu jūsų įrenginyje.",
    trustBanner:
      "💚 Sukurta apie jūsų pirkinių istoriją — ne apie jūsų duomenų rinkimą.",
    bullets: [
      "Paskyra nereikalinga",
      "Debesų sinchronizacija nereikalinga",
      "Vietinis saugojimas",
      "Vartotojo kontroliuojamos atsarginės kopijos",
      "Pasirenkama brūkšninių kodų paieška produktų informacijai.",
      "Remiama reklama per Google AdMob",
    ],
  },
  features: {
    heading: "Viskas, ko reikia",
    subheading:
      "Galingos funkcijos, skirtos paprastam ir privačiam produktų sekimui.",
    items: [
      {
        title: "Brūkšninių kodų skaitytuvas",
        description: "Greitas ir tikslus bet kurio produkto brūkšninio kodo nuskaitymas.",
      },
      {
        title: "Produktų įvertinimai",
        description: "Vertinkite produktus 1–5 žvaigždutėmis, kad prisimintumėte kokybę.",
      },
      {
        title: "Produktų nuotraukos",
        description: "Pridėkite nuotraukas pakuotei ar detalėms prisiminti.",
      },
      {
        title: "Kategorijos",
        description: "Organizaukite produktus į savo kategorijas.",
      },
      {
        title: "Parduotuvių sekimas",
        description: "Prisiminkite, kur pirkote kiekvieną produktą.",
      },
      {
        title: "Kainų registravimas",
        description: "Sekite kainas ir raskite geriausius pasiūlymus.",
      },
      {
        title: "Pirkinių sąrašai",
        description: "Kurkite sąrašus iš mėgstamiausių produktų.",
      },
      {
        title: "Darbas neprisijungus",
        description: "Puikiai veikia be interneto ryšio.",
      },
      {
        title: "Vietinis saugojimas",
        description: "Visi duomenys saugiai saugomi jūsų įrenginyje.",
      },
    ],
  },
  useCases: {
    heading: "Tinka kiekvienai lentynai",
    subheading:
      "Nesvarbu, ar perkate maistą, grožio prekes, ar namų ūkio daiktus — WasOK padeda prisiminti.",
    cards: [
      {
        emoji: "🍫",
        title: "Užkandžiai ir saldumynai",
        description: "Prisiminkite, kurie saldumynai tikrai buvo geri.",
      },
      {
        emoji: "☕",
        title: "Kava ir gėrimai",
        description: "Sekite kavas, kurias verta pirkti vėl.",
      },
      {
        emoji: "💄",
        title: "Kosmetika ir odos priežiūra",
        description: "Laikykite pastabas apie odos reakcijas.",
      },
      {
        emoji: "🧹",
        title: "Namų ūkis",
        description: "Venkite vėl pirkti produktus, kurie nuvylė.",
      },
    ],
  },
  screenshots: {
    heading: "Gražu ir intuityvu",
    subheading:
      "Apgalvota sąsaja, dėl kurios produktų sekimas tampa malonumu.",
    items: [
      { title: "Skaitytuvas" },
      { title: "Produkto detalės" },
      { title: "Įvertinimas" },
      { title: "Paieška ir istorija" },
      { title: "Pirkinių sąrašas" },
    ],
  },
  cta: {
    heading: "Pirkinių atmintis tikram gyvenimui.",
    body: "Nustokite pamiršti, kurie produktai buvo verti pirkti. Pradėkite apsipirkti išmaniau šiandien.",
    googlePlay: "Atsisiųsti iš Google Play",
    scanQr: "Nuskaitykite, kad atsisiųstumėte",
    tagline: "Privatu · Pirmiausia neprisijungus · Paprasta",
  },
  footer: {
    tagline: "Prisiminkite, kas buvo verta pirkti.",
    linksHeading: "Nuorodos",
    privacyPolicy: "Privatumo politika",
    terms: "Paslaugų teikimo sąlygos",
    contact: "Kontaktai",
    linkFaq: "DUK",
    linkLicenses: "Atvirojo kodo licencijos",
    linkAdvertising: "Reklama ir monetizacija",
    downloadHeading: "Atsisiųsti",
    googlePlay: "Google Play",
    copyright:
      "© 2026 WasOK. Visos teisės saugomos. Sukurta su 💚 išmanesniam apsipirkimui.",
  },
  legal: legalMessagesLt,
  faq: pagesMessagesLt.faq,
  support: pagesMessagesLt.support,
  advertising: pagesMessagesLt.advertising,
} satisfies Messages;
